export default __webpack_public_path__ + "static/media/logo.25907852.png";